<template>
  <div 
    class="new_variant_select" 
    :class="[isShowOption ? 'new_variant_select--active' : '']"
  >
    <div 
      class="new_variant_select__button "
      :class="[isShowOption ? 'new_variant_select--active__button' : '']"
      v-clickoutside="handleClose"
      @click="openOption"
    >
      <button 
        type="button"
      >
        <span class="font-text">{{ currentVariant }}</span>
      </button>
      <span class="icon-arrow-up">
        <span class="el-input__suffix-inner">
          <i class="el-select__caret el-input__icon el-icon-arrow-up"></i>
        </span>
      </span>
    </div>
    <div
      v-show="isShowOption" 
      ref="newVariantSelectOption"
      class="new_variant_select__option"
      :class="[isShowOption ? 'new_variant_select--active__option' : '',unfoldDirection]"
    >
      <ul class="variant_list">
        <li 
          class="variant_list__item"
          :class="[currentVariant==subitem?'variant_list__item--is-select':'']"
          v-for="(subitem, subindex) in variantItemList"
          :key="subindex"
          @click="setSelectValue(subitem)"
        >
          <span class="font-text">{{ subitem }}</span>
          <span class="iconfont icon-cm-duigou icon-none" ></span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import mixClose from '@/js/mixins/mixClose'

export default {
  props: {
    currentVariant:{
      type:String,
      require:true,
    },
    variantItemList:{
      type:Array,
      require:true,
    },
    unfoldDirection:{
      type:String,
      require:false,
      default: 'bottom' //option展开的方向 'top':选择器的上部 ; 默认是 'bottom':选择器的下部
    } 
  },
  data() {
    return{
      isShowOption:false,
    }
  },
  mixins: [mixClose],
  methods: {
    openOption() {
      this.isShowOption = !this.isShowOption
    },
    handleClose() {
      this.isShowOption = false
    },
    setSelectValue(data){
      let copyCurrentVariant = this.currentVariant
      copyCurrentVariant = data
      this.$emit('update:currentVariant',copyCurrentVariant);
    },
    setOptionWidth(){
      this.$el.style.setProperty("--content-width",  this.$el.clientWidth+'px');
      this.$el.style.setProperty("--content-bottom", document.documentElement.clientHeight- this.$el.getBoundingClientRect().bottom + this.$el.offsetHeight+'px');
    }
  },
  mounted(){
    window.addEventListener("resize", () => {
      this.setOptionWidth();
    },false);
  },
  watch: {
    isShowOption(newVal){
      this.setOptionWidth();
      this.$emit('visible-change', newVal);
    },
  }
}
</script>

<style lang="scss" scoped>
#app .new_variant_select{
  --content-width: 0 ;
  --content-bottom: 0 ;
  &__button{
    position: relative;
    button{
      width: 100%;
      height: 32px;
      border-radius: 0px ;
      margin: 0px ;
      background-color: #ffffff ;
      border: 1px solid #DCDFE6;
      padding: 0 30px 0 15px ;
      color: #606266;
      .font-text{
        float: left;
        text-decoration: none;
        overflow: hidden;
        text-overflow: ellipsis;
        // display: -webkit-box;
        // -webkit-line-clamp: 1;
        // -webkit-box-orient: vertical;
        white-space: nowrap;
        width: 100%;
        text-align: left;
      }
    }
    .icon-arrow-up{
      position: absolute;
      top: -5px;
      -webkit-transition: all .3s;
      height: 100%;
      color: #C0C4CC;
      text-align: center;
      right: 5px;
      transition: all .3s;
      pointer-events: none;
      transform-origin: 50% 65%;
    }
  }
}
#app .new_variant_select--active{
  &__button{
    .icon-arrow-up{
      transform:  rotateZ(180deg);
    }
  }
  &__option{

    position: fixed;
    background-color: #fff;
    width: calc(var(--content-width));
    overflow: scroll;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    box-sizing: border-box;
    border: 1px solid #E4E7ED;
    border-radius: 4px;
    scrollbar-width: none;
    &::-webkit-scrollbar{
      display: none;
    }
    .variant_list{
      padding: 0;
      margin: 4px 0px;
      list-style: none;
      display: flex;
      flex-direction: column;
      cursor: pointer;
      max-height: 250px;
      &__item{
        display: flex;
        color: #606266;
        padding: 4px 10px;
        font-size: 14px;
        justify-content: space-between;
        .font-text{
          float: left;
          text-decoration: none;
          word-break: break-all;
        }
        .icon-none{
          float: right;
          display: none;
          margin: auto 0;
        }
      }
      &__item--is-select{
        font-weight: 700;
        .icon-none{
          display: block;
        }
      }
      &__item:hover{
        background-color: #f9f9f9;
      }
    }
  }
  .top{
    bottom: calc(var(--content-bottom)) ;
  }
}
</style>